import {request} from './request';

export default
{
    async sendKbaRequest(requestData)
    {
        const rv = await request({
            url: 'api/emission/send-kba-request',
            method: 'post',
            data: requestData
        });

        return rv;
    }
}